/**
 * RE-EDIT QUOTA
 *
 * Re-edits are the only photo operation with a monthly quota.
 * Check before running the AI pass, consume only after it succeeds.
 */
import { supabase } from '@/integrations/supabase/client';

export interface ReeditCheck {
  allowed: boolean;
  message?: string;
}

export async function checkReeditQuota(
  userId: string | undefined,
  options: { listingId?: string | null; photoIndex?: number } = {}
): Promise<ReeditCheck> {
  if (!userId) return { allowed: true };

  const { data, error } = await supabase.rpc('check_reenhancement_eligibility', {
    p_user_id: userId,
    p_listing_id: (options.listingId ?? null) as unknown as string,
    p_photo_index: options.photoIndex ?? 0,
    p_enhancement_type: 'REEDIT',
  });

  if (error) {
    console.warn('Re-edit quota check failed, allowing:', error.message);
    return { allowed: true };
  }

  const row = Array.isArray(data) ? data[0] : undefined;
  if (!row) return { allowed: true };

  return {
    allowed: !!row.can_reenhance,
    message: row.error_message ?? undefined,
  };
}

export async function consumeReeditQuota(userId: string | undefined): Promise<void> {
  if (!userId) return;
  const { error } = await supabase.rpc('increment_monthly_usage', {
    p_user_id: userId,
    p_service_type: 'REEDIT',
    p_count: 1,
  });
  if (error) console.error('Failed to record re-edit usage:', error.message);
}
